import BillingPlanForm from '../forms/BillingPlanForm';
import modal from 'helpers/modal';

export default modal(BillingPlanForm);
